import { FunctionComponent } from "react";
import TestimonialsHeader from "./TestimonialsHeader";
import TestimonialsGrid from "./TestimonialsGrid";
import { reviews, testimonials } from "./data";

const Reviews: FunctionComponent = () => (
  <section className="w-full px-8 py-10 mb-8">
    <TestimonialsHeader title="From Our Clients" />
    <TestimonialsGrid testimonials={[...reviews, ...testimonials]} />
  </section>
);

export default Reviews;
